import { createFileRoute } from '@tanstack/react-router'

import LoginPage from '@/views/auth/login/login.page'

export const Route = createFileRoute('/phong-nha/auth/login')({
  component: LoginPage,
})

